import script from "./RadioInput.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioInput.vue?vue&type=script&setup=true&lang=js"

import "./RadioInput.vue?vue&type=style&index=0&id=465b15aa&lang=scss&scoped=true"

import exportComponent from "/builds/aquaverse/thales/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465b15aa"]])

export default __exports__